import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function StickyBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-red-700 shadow-md" data-id="element-233">
      <div className="max-w-7xl mx-auto px-4 py-2 md:py-3 flex flex-col md:flex-row items-center justify-center md:space-x-6 space-y-2 md:space-y-0" data-id="element-234">
        <p className="text-white font-semibold text-sm md:text-base text-center" data-id="element-235">
          Questa offerta speciale scade presto
        </p>
        <div className="scale-75 md:scale-90 origin-center" data-id="element-236">
          <CountdownTimer variant="light" data-id="element-237" />
        </div>
      </div>
    </div>;
}